import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { Globals } from 'src/app/service/global';
import { ReportService } from 'src/app/service/report.service';
import { DrillDownPreviewComponent } from '../drill-down-preview/drill-down-preview.component';
import { Observable } from 'rxjs';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { MatDialog } from '@angular/material/dialog';
import { StatusConversionPipe } from 'src/app/pipe/status-conversion.pipe';
import { computeStyles } from '@popperjs/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-chip',
  templateUrl: './adc-chip.component.html',
  styleUrl: './adc-chip.component.css',
  providers: [StatusConversionPipe]

})
export class AdcChipComponent {

  @Input() type!: string;
  @Input() orgcode!: String;
  @Input() containerHeight: any

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )

  selectedPeriod: string = 'Today';
  selectedMeeting: string = "Today";
  selectedTaskFilter: string = 'Today';
  selectedMeetingFilter: string = 'Today';
  meetingStatus: any;
  loginName: any = "mlakshmi";
  // loginKey:any = "Z2Pd10Jitv6gWDHLWIse/A==";
  loginKey: any = localStorage.getItem('loginKey');
  frameworkChips: any[] = [
    { name: 'Today', color: 'primary' },
    { name: 'This Week', color: 'primary' },
    { name: 'This Month', color: 'primary' },
  ];
  isLoading = false;
  filterOpen = signal<boolean>(true);
  meetingTypes = ['My Meetings', 'Other Meetings']

  gridDrillArr: any = [];

  reportReq = {
    loginName: this.loginName,
    loginKey: this.loginKey,
    templateCode: "",
    gridDrillArr: this.gridDrillArr
  }

  formatedMeetingData: any = {
    myMeetings: [
      {
        "ORGCODE": "CHN",
        "MEETINGHISSTATUS": 1036,
        "MEETING_COUNT_GROUP": "My Meeting",
        "MEETING_DURATION": 240,
        "MEETING_COUNT": 4
      },
      {
        "ORGCODE": "CHN",
        "MEETINGHISSTATUS": 1038,
        "MEETING_COUNT_GROUP": "My Meeting",
        "MEETING_DURATION": 120,
        "MEETING_COUNT": 2
      },

    ],
    otherMeetings: [
      {
        "ORGCODE": "CHN",
        "MEETINGHISSTATUS": 1036,
        "MEETING_COUNT_GROUP": "Other Meetings",
        "MEETING_DURATION": 720,
        "MEETING_COUNT": 12
      },
      {
        "ORGCODE": "CHN",
        "MEETINGHISSTATUS": 1037,
        "MEETING_COUNT_GROUP": "Other Meetings",
        "MEETING_DURATION": 120,
        "MEETING_COUNT": 2
      },
      {
        "ORGCODE": "CHN",
        "MEETINGHISSTATUS": 1038,
        "MEETING_COUNT_GROUP": "Other Meetings",
        "MEETING_DURATION": 1200,
        "MEETING_COUNT": 20
      },
      {
        "ORGCODE": "CHN",
        "MEETINGHISSTATUS": 1039,
        "MEETING_COUNT_GROUP": "Other Meetings",
        "MEETING_DURATION": 60,
        "MEETING_COUNT": 1
      },
      //   {
      //       "ORGCODE": "CHN",
      //       "MEETINGHISSTATUS": "",
      //       "MEETING_COUNT_GROUP": "Other Meetings",
      //       "MEETING_DURATION": 60,
      //       "MEETING_COUNT": 1
      //   },
      //   {
      //     "ORGCODE": "CHN",
      //     "MEETINGHISSTATUS": "",
      //     "MEETING_COUNT_GROUP": "Other Meetings",
      //     "MEETING_DURATION": 60,
      //     "MEETING_COUNT": 1
      // }
    ]
  };
  formatedTaskData: any
  constructor(private dialog: MatDialog, private reportService: ReportService, private globals: Globals, private readonly breakpointObserver: BreakpointObserver, private spinner: NgxSpinnerService) {
    this.spinner.show();
    this.meetingStatus = this.globals.meetingStatus;
    // this.loginName = localStorage.getItem('loginName');
    // this.loginKey = localStorage.getItem('loginKey');
    // if(this.loginName == 'msaranraj'){
    //   this.loginKey = "fbe5yzd8/zqmjK3bHsKEsA=="
    // }
    // if(this.loginName == 'nvgopal'){
    //   this.loginKey = "KYSNjlLGqpcD8BKzjXE/eg=="
    // }
    // if(this.loginName == 'mlakshmi'){
    //   this.loginKey = "+ATs8Vicq5L9EeZgPv0kig=="
    // }
    this.reportReq.loginName = this.loginName;
    this.reportReq.loginKey = this.loginKey;
  }

  ngOnInit(): void {
    this.gridDrillArr = [{
      "colAlias": "ORGCODE",
      "condition": "~eq~",
      "operator": "AND",
      "startBrace": "(",
      "endBrace": ")",
      "conditionValue": this.orgcode,
      "conditionType": "",
      "conditionCategory": "",
      "conditionConstant": ""
    }]
    this.reportReq.gridDrillArr = this.gridDrillArr;
    if (this.type == 'meeting') {
      this.reportReq.templateCode = "SYS_meeting_count_latest_81"

      // switch(this.selectedPeriod){
      //   case 'Today':
      //     this.reportReq.templateCode = "SYS_meeting_count_latest_81"
      //     break;
      //   case 'This Week':
      //     this.reportReq.templateCode = "SYS_meeting_ubiq_count_80"
      //     break;
      //   case 'This Month':    
      //     this.reportReq.templateCode = "SYS_meeting_count_new_82"
      //     break;
      // }

    } else {
      this.reportReq.templateCode = "SYS_daily_task_count_83"


    }

    this.reportService.getPhemeReportData(this.reportReq).subscribe((data: any) => {
      this.spinner.hide();
      if (this.type == 'meeting') {
        this.formatedMeetingData = {
          myMeetings: data.body ? data.body.filter((meeting: any) => meeting.MEETING_COUNT_GROUP === "My Meeting") : [],
          otherMeetings: data.body ? data.body.filter((meeting: any) => meeting.MEETING_COUNT_GROUP === "Other Meetings") : []
        };

      }
      else {
        this.formatedTaskData = {
          myMeetings: data.body ? data.body.filter((meeting: any) => meeting.TASKUSERGROUP === "MyMeeting") : [],
          otherMeetings: data.body ? data.body.filter((meeting: any) => meeting.TASKUSERGROUP === "OtherMeetings") : []
        };

      }
    })
  }



  periodChange(event: any, name: any) {
    this.isLoading = true;
    if (this.type == 'meeting') {
      this.selectedMeetingFilter = name;
      switch (this.selectedMeetingFilter) {
        case 'Today':
          this.reportReq.templateCode = "SYS_meeting_count_latest_81"
          break;
        case 'This Week':
          this.reportReq.templateCode = "SYS_meeting_ubiq_count_80"
          break;
        case 'This Month':
          this.reportReq.templateCode = "SYS_meeting_count_new_82"
          break;
      }
    }
    else {
      this.selectedTaskFilter = name;
      switch (name) {
        case 'Today':
          this.reportReq.templateCode = "SYS_daily_task_count_83"
          break;
        case 'This Week':
          this.reportReq.templateCode = "SYS_weekly_task_count_85"
          break;
        case 'This Month':
          this.reportReq.templateCode = "SYS_monthly_task_count_84"
          break;
      }
    }
    this.reportService.getPhemeReportData(this.reportReq).subscribe((data: any) => {
      this.isLoading = false;
      if (this.type == 'meeting') {
        this.formatedMeetingData = {
          myMeetings: data.body.filter((meeting: any) => meeting.MEETING_COUNT_GROUP === "My Meeting"),
          otherMeetings: data.body.filter((meeting: any) => meeting.MEETING_COUNT_GROUP === "Other Meetings")
        };

        //   this.formatedMeetingData = {
        //     myMeetings:  [
        //       {
        //           "ORGCODE": "CHN",
        //           "MEETINGHISSTATUS": 1040,
        //           "MEETING_COUNT_GROUP": "My Meeting",
        //           "MEETING_DURATION": 240,
        //           "MEETING_COUNT": 4
        //       },
        //       {
        //           "ORGCODE": "CHN",
        //           "MEETINGHISSTATUS": 1041,
        //           "MEETING_COUNT_GROUP": "My Meeting",
        //           "MEETING_DURATION": 120,
        //           "MEETING_COUNT": 2
        //       },

        //   ],
        //   otherMeetings:  [
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1036,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 720,
        //         "MEETING_COUNT": 12
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1037,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 120,
        //         "MEETING_COUNT": 2
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1038,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 1200,
        //         "MEETING_COUNT": 20
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1039,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 60,
        //         "MEETING_COUNT": 1
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": "",
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 60,
        //         "MEETING_COUNT": 1
        //     }
        // ]
        //   }
      }
      else {
        this.formatedTaskData = {
          myMeetings: data.body.filter((meeting: any) => meeting.TASKUSERGROUP === "MyMeeting"),
          otherMeetings: data.body.filter((meeting: any) => meeting.TASKUSERGROUP === "OtherMeetings")
        };

        //   this.formatedTaskData = {
        //     myMeetings:  [
        //       {
        //           "ORGCODE": "CHN",
        //           "MEETINGHISSTATUS": 1040,
        //           "MEETING_COUNT_GROUP": "My Meeting",
        //           "MEETING_DURATION": 240,
        //           "MEETING_COUNT": 4
        //       },
        //       {
        //           "ORGCODE": "CHN",
        //           "MEETINGHISSTATUS": 1041,
        //           "MEETING_COUNT_GROUP": "My Meeting",
        //           "MEETING_DURATION": 120,
        //           "MEETING_COUNT": 2
        //       },

        //   ],
        //   otherMeetings:  [
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1036,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 720,
        //         "MEETING_COUNT": 12
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1037,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 120,
        //         "MEETING_COUNT": 2
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1038,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 1200,
        //         "MEETING_COUNT": 20
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": 1039,
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 60,
        //         "MEETING_COUNT": 1
        //     },
        //     {
        //         "ORGCODE": "CHN",
        //         "MEETINGHISSTATUS": "",
        //         "MEETING_COUNT_GROUP": "Other Meetings",
        //         "MEETING_DURATION": 60,
        //         "MEETING_COUNT": 1
        //     }
        // ]
        //   }

      }
    })
  }

  //cardbackgroundcolor

  getBackgroundColor(type: any) {
    switch (type) {
      case 'Completed':
        // return '#4CAF50';
        return 'linear-gradient(to top,rgb(76, 175, 96) 43%, #ffff 127%)';
      case 'Cancelled':
        return '#FDEDED';
      case 'Scheduled':
        return 'linear-gradient(to top, #2196F3 33%, #00000033 100%)';
      case 'Yet To Schedule':
        return 'linear-gradient(to top, rgb(96, 125, 139) 23%, #8080806e 100%)';
      case 'Upcoming':
        return 'linear-gradient(to bottom, #009688 33%, #ffffff 100%)';
      case 'Overdue':
        return 'linear-gradient(to bottom, #F44336 33%, #ffffff 100%)';
      case 'In Progress':
        return 'linear-gradient(to top, #3F51B5 33%, #ffffff 122%)';
      default:
        return '#E8F0FE';

    }
  }


  getMeetings(event: any) {
    if (event.MEETING_COUNT_GROUP == 'My Meeting' || event.TASKUSERGROUP == 'MyMeeting') {
      //If meeting data means inside will go if task data means else will call
      if (this.type === 'meeting') {
        var meetReq = {
          start: 0,
          rows: 0,
          loginName: this.loginName,
          loginKey: this.loginKey,
          templateCode: "SYS_drilldownmeetingdata_77",
          gridDrillArr: [{
            "colAlias": "ORGCODE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.orgcode,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          },
          {
            "colAlias": "MEETINGHISSTATUS",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": event.MEETINGHISSTATUS.toString(),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          }, {
            "colAlias": "FK_SECUSERATTENDEE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": localStorage.getItem('userId'),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          }]
        }
        if (this.selectedPeriod == 'Today') {
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().today,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else if (this.selectedPeriod == 'This Week') {
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else {
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }

        const dialogRef = this.dialog.open(DrillDownPreviewComponent, {
          data: { dataSource: "meeting", req: meetReq },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: {
            left: "0%"
          },
          maxWidth: "100vw",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        })
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('70vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          } else {
            dialogRef.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          }
        })
        dialogRef.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        });

      }
      //if task means
      else {
        var taskReq = {
          start: 0,
          rows: 0,
          loginName: this.loginName,
          loginKey: this.loginKey,
          templateCode: "SYS_drilldowntaskdata_78",
          gridDrillArr: [{
            "colAlias": "ORGCODE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.orgcode,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          },
          {
            "colAlias": "STATUS",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getKeyByValue(this.globals.TaskStatus, event.TASK_STATUS),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          },
          {
            "colAlias": "FKSECUSEROWNER",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": localStorage.getItem('userId'),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          }]
        }
        if (this.selectedPeriod == 'Today') {
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().today,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else if (this.selectedPeriod == 'This Week') {
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else {

          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })

        }
        // this.reportService.getDrilldownTaskData(taskReq).subscribe((data: any) => {
        // })
        if (event.TASK_STATUS == 'OverDue') {
          taskReq.templateCode = "SYS_drilldown_overdue_task_86"
        }
        const dialogRef = this.dialog.open(DrillDownPreviewComponent, {
          data: { dataSource: "task", req: taskReq },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: {
            left: "0%"
          },
          maxWidth: "100vw",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        })
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('70vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          } else {
            dialogRef.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          }
        })
        dialogRef.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        });
      }

    }
    //others block
    else {
      //meeting means
      if (this.type === 'meeting') {
        var meetReq = {
          start: 0,
          rows: 0,
          loginName: this.loginName,
          loginKey: this.loginKey,
          templateCode: "SYS_drilldownmeetingdata_77",
          gridDrillArr: [{
            "colAlias": "ORGCODE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.orgcode,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          },
          {
            "colAlias": "MEETINGHISSTATUS",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": event.MEETINGHISSTATUS.toString(),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          }, {
            "colAlias": "FK_SECUSERATTENDEE",
            "condition": "~neq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": localStorage.getItem('userId'),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          }]
        }
        if (this.selectedPeriod == 'Today') {
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().today,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else if (this.selectedPeriod == 'This Week') {
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else {
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          meetReq.gridDrillArr.push({
            "colAlias": "MEETING_DATE",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }

        // this.reportService.getDrilldownMeetingData(taskReq).subscribe((data: any) => {
        const dialogRef = this.dialog.open(DrillDownPreviewComponent, {
          data: { dataSource: "meeting", req: meetReq },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: {
            left: "0%"
          },
          maxWidth: "100vw",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        })
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('70vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          } else {
            dialogRef.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          }
        })
        dialogRef.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        });
        // }) 
      }
      // task means
      else {
        var taskReq = {
          start: 1,
          rows: 5,
          loginName: this.loginName,
          loginKey: this.loginKey,
          templateCode: "SYS_drilldowntaskdata_78",
          gridDrillArr: [{
            "colAlias": "ORGCODE",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.orgcode,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          },
          {
            "colAlias": "STATUS",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getKeyByValue(this.globals.TaskStatus, event.TASK_STATUS),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          },
          {
            "colAlias": "FKSECUSEROWNER",
            "condition": "~neq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": localStorage.getItem('userId'),
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          }]
        }
        if (this.selectedPeriod == 'Today') {
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~eq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().today,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else if (this.selectedPeriod == 'This Week') {
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().weekEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
        }
        else {

          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~gteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthStart,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })
          taskReq.gridDrillArr.push({
            "colAlias": "CREATEDON",
            "condition": "~lteq~",
            "operator": "AND",
            "startBrace": "(",
            "endBrace": ")",
            "conditionValue": this.getDateRanges().monthEnd,
            "conditionType": "",
            "conditionCategory": "",
            "conditionConstant": ""
          })

        }
        // this.reportService.getDrilldownTaskData(taskReq).subscribe((data: any) => {
        // })
        const dialogRef = this.dialog.open(DrillDownPreviewComponent, {
          data: { dataSource: "task", req: taskReq },
          panelClass: ['animate__animated', 'animate__slideInLeft'],
          disableClose: true,
          position: {
            left: "0%"
          },
          maxWidth: "100vw",
          maxHeight: "100vh",
          width: "50%",
          height: "100vh"
        })
        const mediumDialogSubscription = this.isMedium.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('70vw', '100vh');
          }
        })
        const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          } else {
            dialogRef.updateSize('calc(100% - 50px)', '100vh');
          }
        });
        const smallSubscription = this.isSmall.subscribe(size => {
          if (size.matches) {
            dialogRef.updateSize('100vw', '100vh');
          }
        })
        dialogRef.afterClosed().subscribe((data) => {
          mediumDialogSubscription.unsubscribe()
          smallSubscription.unsubscribe()
          smallDialogSubscription.unsubscribe()
        });
      }
    }

  }


  getKeyByValue(map: Map<string, string>, value: string): string | undefined {
    for (const [key, val] of map.entries()) {
      if (val === value) {
        return key;
      }
    }
    return undefined; // Return undefined if not found
  }

  getDateRanges() {
    const today = new Date();

    // Helper function to format date as MM/DD/YYYY
    const formatDate = (date: Date): string =>
      `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${date.getDate().toString().padStart(2, '0')}/` +
      `${date.getFullYear()}`;

    // Today
    const todayDate = formatDate(today);

    // Week Start (Sunday) and Week End (Saturday)
    const dayOfWeek = today.getDay();
    const weekStart = new Date(today);
    weekStart.setDate(today.getDate() - dayOfWeek);
    const weekEnd = new Date(today);
    weekEnd.setDate(today.getDate() + (6 - dayOfWeek));

    // Month Start and Month End
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

    return {
      today: todayDate,
      weekStart: formatDate(weekStart),
      weekEnd: formatDate(weekEnd),
      monthStart: formatDate(monthStart),
      monthEnd: formatDate(monthEnd),
    };
  }


  //active tab

  setActiveTab2(tabName: string, tabId: string): void {
    const parentElement = document.getElementById(tabId);
    const tabButtons = parentElement?.querySelectorAll(
      ".adc-tab-button"
    ) as NodeListOf<HTMLElement>;
    const tabContent = parentElement?.querySelectorAll(
      ".adc-tab-pane"
    ) as NodeListOf<HTMLElement>;

    tabContent.forEach((content: HTMLElement) => {
      content.classList.remove("active");
      if (content.getAttribute("data-tab-name") === tabName) {
        content.classList.add("active");
        if (tabName === 'tab4') {
          content.classList.remove('overflow-y-auto');
        }
      }
    });

    tabButtons.forEach((btn: HTMLElement) => {
      btn.classList.remove("active");
      if (btn.getAttribute("data-tab-target") === tabName) {
        btn.classList.add("active");
      }
    });
  }

  activemeeting = 'My Meetings';
  activeTask = 'My Meetings';
  activeMeetingTypes(name: any, type: string = '') {
    if (type == 'task') {
      this.activeTask = name;
    } else {
      this.activemeeting = name;
    }

  }


}
